module.exports = __webpack_public_path__ + "static/media/accordion.b32cf55d.png";